import React from 'react'
import { Link } from 'react-static'

import ReactGA from 'react-ga'

import NavLink from 'components/Nav-Link'
import ColorBar from 'components/Color-Bar'

import Logo from 'static/img/logo-glenbeigh.png'

class Header extends React.Component {
  gaEvent = (category, action, label) => {
    ReactGA.event({
      category: category,
      action: action,
      label: label
    })
  }

  render() {
    return (
      <React.Fragment>
        <ColorBar />
        <nav className="site-nav container">
          <Link to="/" className="logo-glenbeigh">
            <img src={Logo} />
          </Link>
          <NavLink to="/">
            <Link to="/" className="" onClick={this.gaEvent('Navigation', 'Click on Nav link', 'Home')}>
              <span>Home</span>
            </Link>
          </NavLink>
          <NavLink to="/projects">
            <Link to="/projects" onClick={this.gaEvent('Navigation', 'Click on Nav link', 'Projects')}>Projects</Link>
          </NavLink>
          <li className="site-nav__item">
            <Link to="#contact" className="" onClick={this.gaEvent('Navigation', 'Click on Nav link', 'Contact')}>
              <span>Contact</span>
            </Link>
          </li>
        </nav>
      </React.Fragment>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Header.js